import {
  Box,
  type MantineSize,
  type MantineColor,
  type BoxProps,
} from '@mantine/core'
import { clsx } from 'clsx'
import { type PropsWithChildren, type CSSProperties } from 'react'

import styles from './styles.module.css'

export type PulseProps = PropsWithChildren<BoxProps> & {
  color?: MantineColor | 'brand'
  radius?: MantineSize | number
  intensity?: MantineSize | number
  animate?: boolean
}

export function Pulse({
  color = 'gray',
  radius = 'xl',
  intensity = 'xs',
  animate = true,
  children,
  ...props
}: PulseProps) {
  const classes = clsx(styles.pulse, styles[color], {
    [styles.animate]: animate,
    [styles[`radius_${radius}`]]: typeof radius === 'string' ? radius : false,
    [styles[`intensity_${intensity}`]]:
      typeof intensity === 'string' ? intensity : false,
  })

  const inlineStyles: CSSProperties | undefined =
    typeof radius === 'number' ? { borderRadius: `${radius}px` } : undefined

  return (
    <Box {...props} className={classes} style={inlineStyles}>
      {children}
    </Box>
  )
}
